import type { FormHTMLAttributes, ReactNode } from 'react';

import { cn } from '../../lib/utils';
import type { UseFormResult } from './useForm';

type FormProps<T> = Omit<FormHTMLAttributes<HTMLFormElement>, 'onSubmit'> & {
  form: UseFormResult<T>;
  children: ReactNode;
};

/**
 * Thin `<form>` wrapper that hooks `submit()` into the native submit event.
 * Pair with `<FormField>` for label/error chrome and `useForm` for state.
 *
 * Use a `<Button type="submit">` (or any submit-typed control) inside; clicking
 * it triggers `form.submit()`.
 */
export function Form<T>({ form, className, children, ...props }: FormProps<T>) {
  return (
    <form
      {...props}
      className={cn('flex flex-col gap-4', className)}
      onSubmit={(e) => {
        e.preventDefault();
        void form.submit();
      }}
      noValidate
    >
      {children}
    </form>
  );
}
